const siteMetadata = {
  title: 'Vincent Chau',
  author: 'Vincent C.',
  dev: 'Vincent C.',
  headerTitle: 'Vincent Chau',
  description: 'Welcome to my Website!',
  language: 'en-us',
  theme: 'system', // system, dark or light
  siteUrl: 'https://www.vincentczhou.github.io',
  siteRepo: 'https://www.github.com/vincentczhou/InfoSec-Club-Site',
  siteLogo: '/static/images/avatars/default.png',
  image: '/static/images/avatars/default.png',
  socialBanner: '/static/images/avatars/default.png',
  email: 'vkchau@uw.edu', // 'vincent.chau@bellevuecollege.edu.com',
  github: 'https://www.github.com/vincentczhou',
  linkedin: 'https://www.linkedin.com/in/vincentkchau',
  ctftime: 'https://www.ctftime.com',
  homepage: 'https://www.vincentczhou.github.io',
  locale: 'en-US',
}

module.exports = siteMetadata
